import React from 'react';
import GongqiFormItemControl from './GongqiFormItemControl';
import FormItemUtil from '../../utils/FormItemUtil';
import FormResourceUtil from '../../utils/FormResourceUtil';

import CommandResolver from '../../utils/CommandResolver';
import ServiceHelper from '../../remote/ServiceHelper';
import CommandHelper from '../../remote/CommandHelper';
import FormItemDataGrid from '../FormItemDataGrid';
import FormItemConst from '../FormItemConst';
import GongqiHeaderCell from '../../export/GongqiHeaderCell';
import {RecordsCmpStore} from '../../stores/RecordsStore';
import GongqiSelectRecordsHeaderCell from '../renders/GongqiSelectRecordsHeaderCell';
import GOTUtil from '../../utils/GOTUtil';
import GOT from '../../utils/GOT';

export default class FormItemDataGridControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
    this.classAlias = "FormItemDataGridControl";
    this.module = module;
    this.rowHeight = undefined;
		if(this.groupAlias == "")
		{
			let columnsFormItem = this.xml.FormItem;
			if(columnsFormItem.length == 0)
				return;
			let i = 0;
			let columnFormItem = columnsFormItem[i]
			while(i<columnsFormItem.length && columnFormItem.Properties.DataSource.Value == "")
			{
				columnFormItem = columnsFormItem[++i];
			}
			this.groupAlias = columnFormItem.Properties.DataSource.Value;
		}

     this.unsubscribeRecordsCmpStore = RecordsCmpStore.listen(this.onExecuteCmp.bind(this));
	}

  getProperty_LockedNum()
  {
    var _parentWindow = window.parent.window;
    if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
    {
      let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
      let _properties = _userProperties[this.xml.id];
      if(_properties && _properties.hasOwnProperty("lockedNum"))
        return _properties["lockedNum"];
      else if(_properties && _properties.hasOwnProperty("lockednum"))
        return _properties["lockednum"];
    }
    if(!this.properties.hasOwnProperty("FreezeColumns"))
      this.properties.FreezeColumns = 0;
    return this.properties.FreezeColumns;
  }

  getProperty_HeaderHeight()
  {
    return this.properties.HeaderHeight;
  }

  getProperty_DisableAutoSave()
  {
    if(this.properties.hasOwnProperty("ShowToolbar"))
      return this.properties.DisableAutoSave;
    return false;
  }

  getProperty_ShowToolbar()
  {
    if(this.properties.hasOwnProperty("ShowToolbar"))
      return this.properties.ShowToolbar;
    return true;
  }


  onExecuteCmp(data,groupAlias,groupInstance)
  {
    if(this.group && this.group == groupInstance && this.group.groupAlias == groupAlias)
    {
      this.records = data;
    }
  }

  enterMainForm(columnIndex,_value)
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    if(columnFormItemControl.enterMainForm)
      columnFormItemControl.enterMainForm({currentValue:_value});
  }

  ascOrder(columnIndex)
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    columnFormItemControl.ascOrder();
  }
  descOrder(columnIndex)
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    columnFormItemControl.descOrder();
  }


  findValue(columnIndex)
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    columnFormItemControl.findValue();
  }

  findValue2(columnIndex,flag='')
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    columnFormItemControl.findValueStepByStep(flag);
  }

  enterFind(columnIndex)
  {
    let columnsFormItem = this.columnsDataFlat;
    if(columnsFormItem.length == 0)
      return;
    if(columnIndex-1<0)
      return;
    let columnFormItem = columnsFormItem[columnIndex-1];
    let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,columnFormItem.id);
    let columnFormItemControl = FormItemUtil.getFormItemControl(key,false);
    columnFormItemControl.enterFind();
  }
  
  getDynamicColumnName()
  {
    let dynamicPropertyValue = GOTUtil.getPropertyValue(this.xml,"DynamicColumn");
    if(!dynamicPropertyValue && this.group && this.group.mainSource && this.group.mainSource.xml && this.group.mainSource.xml.Properties.PivotSource && this.group.mainSource.xml.Properties.PivotSource.Value){
      let columnsData = this.xml.FormItem;
      let pivotSourceEntityid = this.group.mainSource.xml.Properties.PivotAggregateColumn.refentityid;
      let pivotSourceValue= this.group.mainSource.xml.Properties.PivotAggregateColumn.Value;
      if(pivotSourceEntityid && pivotSourceValue){
        for(let i in columnsData)
        {
          let columnItem = columnsData[i];
          if(columnItem && columnItem.Properties &&columnItem.Properties.Extends && pivotSourceValue == columnItem.Properties.Extends.Value && pivotSourceEntityid == columnItem.Properties.Extends.refentityid){
             dynamicPropertyValue = columnItem.name;
            break;
          }
          
  
        }
      }
    }
    return dynamicPropertyValue;
  }

	getDataGridColumns()
	{
      //alert("getDataGridColumns" + this.groupAlias);
		  let columnsData = this.xml.FormItem;
      let columnsDataFlat = [];
      let dynamicPropertyValue = GOTUtil.getPropertyValue(this.xml,"DynamicColumn");
      if(dynamicPropertyValue)
        this.group.hasDynamicColumn = true;

      if(!dynamicPropertyValue && this.group && this.group.mainSource && this.group.mainSource.xml && this.group.mainSource.xml.Properties.PivotSource && this.group.mainSource.xml.Properties.PivotSource.Value){
        let pivotSourceEntityid = this.group.mainSource.xml.Properties.PivotAggregateColumn.refentityid;
        let pivotSourceValue= this.group.mainSource.xml.Properties.PivotAggregateColumn.Value;
        let pivotSourceName =  this.group.mainSource.xml.Properties.PivotSource.Value;
        if(pivotSourceEntityid && pivotSourceValue){
          for(let i in columnsData)
          {
            let columnItem = columnsData[i];
            if(columnItem && columnItem.Properties &&columnItem.Properties.Extends && pivotSourceValue == columnItem.Properties.Extends.Value && pivotSourceEntityid == columnItem.Properties.Extends.refentityid){
              this.group.hasDynamicColumn = true;
              dynamicPropertyValue = columnItem.name;
              break;
             }
            
          }
        }
      }
      for(let i in columnsData)
      {
        let columnItem = columnsData[i];
        if(columnItem.type == "FieldGroup")
        {
          let fieldGroupFormItemArray = columnItem.FormItem;
          for(let j in fieldGroupFormItemArray)
          {
            columnsDataFlat.push(fieldGroupFormItemArray[j]);
          }
        }
        else
        {
          columnsDataFlat.push(columnItem);
        }
      }
      let columns = [];
      let columnLockedNum = this.getProperty_LockedNum();
      columnLockedNum = parseInt(columnLockedNum);
      let num = 0;
      this.columnsDataFlat = columnsDataFlat;
	    for(let i in columnsDataFlat)
	    {
        let columnItem = columnsDataFlat[i];
        if(columnItem.name == dynamicPropertyValue)
          continue;
	      /*key: 'county',
	      name: 'County',
	      editor: <AutoCompleteEditor options={counties}/>,
	      width: 200,
	      resizable: true*/
	      let column = {};
        if(num<columnLockedNum)
          column.locked = true;
        let controlKey = FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,columnItem.id);
        let columnControl = FormItemUtil.getFormItemControl(controlKey,this.forLookup);
        let columnDisplayHeight = columnControl.getProperty_DisplayHeight();
        let columnFixHeight = columnControl.getProperty_Height();
        if(!this.columnDisplayHeight && columnFixHeight && columnFixHeight>0)
          this.columnDisplayHeight = columnFixHeight;
        else if(columnDisplayHeight && columnDisplayHeight>1 && !this.columnDisplayHeight)
        {
          this.columnDisplayHeight = columnDisplayHeight*FormItemConst.DATAGRID_ROW_HEIGHT;
        }
	      column.key = columnControl.getDataField();
	      if(column.key == undefined)column.key = "1";
	      column.name = columnControl.getInitialLabel();
        column.skipTab = columnControl.getProperty_SkipTab();
        column.isDataMethodField = columnControl.isDataMethodField;
          //FormItemUtil.getFormItemInstanceForDataGrid(columnItem,false);

	      // column.width = columnControl.getDisplayLengthWidth();
        let _width = columnControl.getProperty_Width();
        if(_width!=""&&typeof(_width)=="string")_width = parseInt(_width);
        if(!_width)
        {
          let _displayLength=columnControl.propertyDisplayLength?columnControl.propertyDisplayLength:columnControl.getProperty_DisplayLength();
          if(_displayLength == FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH)_displayLength=FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH+1;
          column.width=_displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon;
        }
        else
        {
          column.width = _width;
        }
        if(columnItem.type == "DateEditor")//TODO 由于项目编辑器焦点框特殊实现 DataGrid外的宽度逻辑会造成有焦点时少显示4分之一字 所以加了2个像素宽度
          column.width+=FormItemConst.DATAEDITOR_DATAGRID_ADDON_FOCUS;

        //if(columnItem.type == "BooleanEditor")
        //  column.width += 20;
        column.widthBak = column.width;
        column.notNull=columnControl.getInitialNotNull();
        column.uid = columnItem.id;
        column.xmlName = columnItem.name;
        column.resizable = true;
        column.editorType = columnItem.type;
        var groupAlias=this.groupAlias;
        let _textAlign = columnControl.getProperty_Alignment();
        if(!_textAlign)_textAlign="Left";
        if(columnControl.isDataMethodSelectRecords)
        {
          column.headerRenderer = <GongqiSelectRecordsHeaderCell moduleInstanceId={this.module.instanceUUId} groupAlias={groupAlias}/>;
          column.resizable = false;column.editable = false;
        }
        else
        {
          column.headerRenderer=<GongqiHeaderCell moduleInstanceId={this.module.instanceUUId} groupAlias={groupAlias} textAlign={_textAlign.toLowerCase()}/>;
        }
        //TODO非常重要 借用宽度来实现不可见
	      if(columnControl.getProperty_Visible_Final() == false)
        {
          column.width = 0.1;
          column.visible = false;
        }
        if(columnItem.type == "BooleanEditor")
        {
          column.editable = false;
        }
        else
        {
          let _editor = columnControl.getComponentInstanceForDataGrid(this.xml,this.forLookup);
          column.editor = _editor;  
        }
        
        if(columnItem.type == "DecimalEditor")
        {
          column.numofdecimals = columnControl.getProperty_NumOfDecimals();
        }
        if(this.module.rendersObject && this.module.rendersObject.hasOwnProperty(column.xmlName))
        {
          let _arg = this.module.rendersObject[column.xmlName];
          if(_arg)
          {
            let CustomRender = _arg.render;
            column.formatter = <CustomRender executeCommandResult = {this.executeCommandResult.bind(this)}/>;
            if(_arg.editable == false)
            {
              column.editable = false;
              column.editor = null;
            }
          }
        }
        else
        {
          column.formatter = columnControl.getRenderForDataGrid(this.forLookup);
        }

        if(this.module.dragStartObjects && this.module.dragStartObjects.hasOwnProperty(column.xmlName))
        {
          let _arg = this.module.dragStartObjects[column.xmlName];
          if(_arg)
          {
            let _handler = _arg.handler;
            column.dragStartHandler = _handler;
          }
        }else{
          // if(window.parent.window.appId && window.parent.window.didomain){
            column.dragStartHandler = this.columndragStartHandler.bind(this);
          // }
        }
        
        /*if(column.width!=0.1 && i == columnsDataFlat.length-1)
        {
          column.width +=25;
        }*/
        /*if(i == columnsDataFlat.length-1)
          {column.width = 0.1;column.visible = false;}*/

        /*if(window.isDataSetView==true)
        {
          let extendsPro = GOTUtil.getProperty(columnItem,"Extends");
          if(extendsPro && extendsPro.refentityid && extendsPro.refinnerid)
          {
            let extendsTable = GOT.getTable(extendsPro.refentityid);
            if(extendsTable)
            {
              let tableField = GOT.getTableField(extendsTable,extendsPro.refinnerid);
              if(tableField && tableField.type == "Component")
              {
                column.key = column.key.replace(/\./g,"_");
              }
            }
          }
        }*/

        columns.push(column);
        // if(column.width > 0.1)
          num ++;
	    }
	    console.log(columns);
      this._columns = columns
	    return columns;
  }

  columndragStartHandler(event,billData){
    if(billData) billData.name = this.module.formLabel+".xlg";
    event.dataTransfer.setData("billData", JSON.stringify(billData));
  }

  executeCommandResult(commandResult)
  {
    CommandResolver.resolve(commandResult.tasks, window.formModuleInstance);
  }

  /*onTabNavHandler(proxy,rowIndex,columnIndex)
  {
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
      if(ne.shiftKey)
      {

      }
    }
  }*/

  getStyle()
	{
    let parentLayout = this.parentXML.Properties.Layout.Value;
    
    let style = {
      //align-items:flex-start,
      //flex-grow:flexGrow
    };
    
    
    if(this.forLookup || window.isLookup || window.isPopUp)
    {
      //let columnWidth = this._columns.length*200-120;
      //style["width"] = columnWidth +"px";
      let totalWidth = 46;
      for(let i in this._columns)
      {
        let column = this._columns[i];
        totalWidth+=column.width;
      }

     // if(totalWidth>($(document).width()-300))
     //   totalWidth = $(document).width() - 300;
      if(totalWidth<387)
        totalWidth = 387;
      style["minWidth"] = (totalWidth) +"px";
    }

    /*if(window.isPopUp)
    {
      let totalWidth = 48;
      for(let i in this._columns)
      {
        let column = this._columns[i];
        totalWidth+=column.width;
        if(i>5)
          break;
      }
      if(totalWidth<350)totalWidth = 350;
      style["minWidth"] = (totalWidth) +"px";
      
    }*/


    if(parentLayout == "horizontal")
    {
     
      let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
      if(_width == undefined || _width == 0)
        _width = "";
      if(typeof(_width) == "number")_width=_width+"";
      let flexGrow = 100;
      let iex = _width.indexOf("%");
      if(iex!=-1)
      {
        flexGrow = _width.substring(0,iex);
      }

      if(iex==-1&&_width != "")
      {
        style["width"] = _width+"px";
      }
      else
      {
        style["flexGrow"] = flexGrow; 
      }
     
      let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
      if(_height == undefined)
        _height = "";
      if(this.forLookup || window.isPopUp || window.isLookup || this.xml.Properties.Rows.Value)// && this.module.hasUpDownDataGrid))
      {
        //alert(this.xml.Properties.Rows.Value);
        if(!this.xml.Properties.Rows.Value) this.xml.Properties.Rows.Value = 16;

        let _rowsNum = this.xml.Properties.Rows.Value;
        let _extralHeight = 39;

        if(_rowsNum == 4)
        {
          _extralHeight = 49;
        }
       
        style["height"] = parseInt(_rowsNum)*(this.columnDisplayHeight?this.columnDisplayHeight:FormItemConst.DATAGRID_ROW_HEIGHT) + FormItemConst.DATAGRID_HEADER_HEIGHT + _extralHeight +"px";
        
      }
      else if(_height == "100%" || _height == "")
        style["alignSelf"] = "stretch";
      else if(_height.indexOf("%") != -1)
        style["height"] = _height;
      else if(_height != "")
        style["height"] = _height+"px";

    }
    else //vertical 暂不考虑absolute
    {
      let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
      if(_height == undefined || _height == 0)
        _height = "";
      if(typeof(_height) == "number")_height=_height+"";
      let flexGrow = 100;//this.props.xml.Properties.Rows.Value;
      let iex = _height.indexOf("%");
      if(iex!=-1)
      {
        flexGrow = _height.substring(0,iex);
      }
      else if(iex==-1&&_height != "")
      {
        flexGrow = _height+"px";
      }
      else if(_height == "")
      {
        if(this.forLookup || window.isPopUp || window.isLookup || (this.xml.Properties.Rows.Value))// && this.module.hasUpDownDataGrid))
        {
          if(!this.xml.Properties.Rows.Value) this.xml.Properties.Rows.Value = 16;
          let _rowsNum = this.xml.Properties.Rows.Value;
          let _extralHeight = 39;

          if(_rowsNum == 4)
          {
            _extralHeight = 49;
          }
          style["height"] = parseInt(_rowsNum)*(this.columnDisplayHeight?this.columnDisplayHeight:FormItemConst.DATAGRID_ROW_HEIGHT) + FormItemConst.DATAGRID_HEADER_HEIGHT + _extralHeight +"px";
          style["flexShrink"] = 0;
        }
      }
      if(!style.hasOwnProperty("height"))
        style["flexGrow"] = flexGrow;

      

      let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
      if(_width == undefined)
        _width = "";
      if(_width == "100%" || _width == "")
        style["alignSelf"] = "stretch";
      else if(_width.indexOf("%") != -1)
        style["width"] = _width;
      else if(_width != "")
        style["width"] = _width+"px";
    }
  
    return style;
	}

  remoteReturnHandler()
  {
    var gridName =  this.xml.name;
    var cmdargInfo = FormResourceUtil.getCommandArgMethodInfo("lookupSelect_"+gridName,"FormLookup",this.formId);
    if(cmdargInfo)
    {
      var defaultGroupAlias = this.groupAlias;
      var arg = CommandResolver.getSendCmd(this.module, defaultGroupAlias, cmdargInfo);
      var command = CommandHelper.createFormInstance(this.module.formName, "doLookupSelect", "CommandResult")
                                 .appendArg(gridName, "String").appendArg(arg, "CommandArg");
      var remoteArg = {command:command,resultFunction:this.rpc_remoteClickresult.bind(this),sync:false};
      ServiceHelper.addTokenWithCommand(remoteArg);
      return true;
    }
    return false;
  }

  rpc_remoteClickresult(data)
  {
    var commandResult = data.result;
    CommandResolver.resolve(commandResult.tasks, this.module, this.group);
  }

  autoReturnHandler(record)
  {
    this.module.autoReturnHandler(record);
  }

  isSkipTab()
  {
    //TODO Group折叠考虑
    //if(getGroupParentFolded())
    //  return true;
    
    
    if(!this.getProperty_Visible_FinalusersetLoopForSkip())
      return true;
    if(this.getProperty_ActualSkipTab())
      return true;
    
    return false;
  }
  
  getComponentInstance(parent,forLookup)
	{
	  let layout = parent.Properties.Layout.Value;
	  let columns = this.getDataGridColumns();
    //let store = window.parent.window[storeKey];
	  let allowMutiSelect = true;//store.mapItemProperty[this.formId+"_"+this.xml.id].MultiSelect;
    let _updateHeightPercent100 = false;
    /*if(ptype != "FormDesign")
    {
      //TODO不知道为何 但是要先改掉
      if(layout == "horizontal" && parent.FormItem.length>0)
        _updateHeightPercent100 = true;
    }*/

    var remoteReturnHandler = null;
    var autoReturnHandler = null;
    if(forLookup)
    {
      remoteReturnHandler = this.remoteReturnHandler.bind(this);
      let autoReturn = (this.module.classAlias == "FormModuleLookup")?this.module.autoReturn:false;
      if(autoReturn)
        autoReturnHandler = this.autoReturnHandler.bind(this);
    }
    let commonProps = this.getCommonProps();
    this.component = <FormItemDataGrid columns={columns} key={this.xml.id} xml={this.xml} control={this} hasDividedBox={this.module.hasDividedBox}
                  parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId}
                  allowMutiSelect={allowMutiSelect} customStyle={this.getStyle()} group={this.group}
                  formId={this.formId} menuItemId={this.menuItemId} updateHeightPercent100={_updateHeightPercent100}
                  contextMenuData={this.contextMenuData} remoteReturnHandler={remoteReturnHandler} autoReturnHandler={autoReturnHandler}
                  showToolbar={this.getProperty_ShowToolbar()}
                  initRecords={this.records} headerRowHeightPro={this.getProperty_HeaderHeight()} rowHeight={this.columnDisplayHeight} {...commonProps}/>;
    return this.component;
	}

	
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemDataGridControl.js